import { FormattedMessage } from '@alltrails/shared/react-intl';
import classNames from 'classnames';
import { Key } from 'react';
import PlusBadge from '@alltrails/shared/denali/components/PlusBadge';
import Check from '@alltrails/shared/icons/Check';
import * as styles from './ProFeatureComparisonTable.module.scss';

type Feature = {
  text: JSX.Element;
  pro: boolean;
  new?: boolean;
};

type ProFeatureComparisonTableProps = {
  features: Feature[];
  containerStyles?: string;
};

// https://www.figma.com/file/xpgusAsl6oJxirFq2X94Wz/P_2024-Plus-Updates?type=design&node-id=1201-44935&mode=design&t=GQi2fptC9GeVoBs2-0
const ProFeatureComparisonTable = ({ features, containerStyles }: ProFeatureComparisonTableProps) => (
  <table className={classNames(styles.features, containerStyles)}>
    <thead>
      <tr>
        <th className={styles.head}>
          <FormattedMessage defaultMessage="Features" />
        </th>
        <th>
          <FormattedMessage defaultMessage="Free" />
        </th>
        <th>
          <span>
            <FormattedMessage defaultMessage="AllTrails+" />
          </span>
          <PlusBadge size="md" />
        </th>
      </tr>
    </thead>
    <tbody>
      {features.map((feature, index) => (
        <tr key={index as Key} className={styles.feature}>
          <td>
            {feature.text}
            {feature.new && (
              <div className={styles.newBadge}>
                <FormattedMessage defaultMessage="New" />
              </div>
            )}
          </td>
          <td>{!feature.pro && <Check color="var(--color-text-plus)" size="md" />}</td>
          <td>
            <Check color="var(--color-text-plus)" size="md" />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default ProFeatureComparisonTable;
